export const identity = {
    yourIdentity: {
        revealIdentity: 'Whistleblowers identitet',
        yesRevealIdentity: 'Ja, jeg vil gerne oplyse min identitet',
        noDontRevealIdentity: 'Nej, jeg ønsker at indberette anonymt',
    }
};
